const toggleTaskList = (editor) => {
  editor.chain().focus().toggleTaskList().run();
};

const taskListHandlers = {
  'task-list:toggle': toggleTaskList,
};

export default taskListHandlers;
